
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/openings",
      function () {
        return require("private-next-pages/learn/openings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/openings"])
      });
    }
  